import classNames from "classnames"
import "./Icon.scss";

export function Icon({ type, onClick, ...props })
{
    return (<div styleName={classNames("icon", type)} onClick={onClick} {...props}>
    </div>);
}